<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      _beforeUnload_time: null,
      _gap_time: null,
    }
  },
  created(){
    //console.log("加载：",localStorage.getItem("authorization"),localStorage.getItem("isLogin"),localStorage.getItem("user"))
    this.$axios.defaults.headers.common["Authorization"] = localStorage.getItem("authorization");
    sessionStorage.setItem("isLogin", localStorage.getItem("isLogin"));
    sessionStorage.setItem("user",localStorage.getItem("user"))

  },
  mounted() {
    // 监听页面关闭事件，清空缓存
    window.addEventListener('beforeunload', e => this.beforeunloadHandler(e));
    window.addEventListener('unload', e => this.unloadHandler(e));
  },
  destroyed(){
    // 监听页面关闭事件，清空缓存
    window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e));
    window.removeEventListener('unload', e => this.unloadHandler(e));
  },
  beforeDestroy(){
    localStorage.clear();
  },
  methods:{
    // 辅助监听页面关闭事件，清空缓存
    beforeunloadHandler(){
        this._beforeUnload_time=new Date().getTime();
        //alert("a:"+this._beforeUnload_time)
    },
    // 监听页面关闭事件，清空缓存
    unloadHandler(e){
        // 时间 = 当前时间 - 
        this._gap_time=new Date().getTime()-this._beforeUnload_time;
        // 时间判断，小于 5 为关闭，
        if(this._gap_time<=5){
          //debugger
          //alert("b:"+this._beforeUnload_time+this._gap_time)
          localStorage.clear();
        }
    }
  }
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
html,
body {
  width: 100%;
  height: 100%;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
input,
button {
  outline: none;
}
ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}
a {
  text-decoration: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.el-menu {
  border-right: none;
}
.name-box > .el-input > #search-management {
  width: 240px;
  height: 40px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue